import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { Product } from "~/common/Store/models/ProductListing";

interface Props {
  price: Product["price"];
  mapPrice: number;
  overSizedPriceStyle?: string;
}

const MapOverrideDisabled = ({
  price,
  mapPrice,
  overSizedPriceStyle,
}: Props) => (
  <>
    <div className="map__text">
      <p className="text__discount">
        <span className="text__highlight">
          {formatAsCurrency.formatIfUndefined(price.price - mapPrice)}
        </span>
        {" lower "}
      </p>
      <p className="text__description font-normal">
        <>
          <strong>Add to cart</strong>
          {" to see our "}
          <span className="text__highlight">price!</span>
        </>
      </p>
    </div>

    <div className="map__price">
      <label className="price__label">Retail Price </label>
      <p className={`price ${overSizedPriceStyle}`}>
        {formatAsCurrency.formatIfUndefined(price.price)}
      </p>
    </div>
  </>
);

export default MapOverrideDisabled;
